import { render, staticRenderFns } from "./Fashion.vue?vue&type=template&id=408ca7a0&scoped=true"
import script from "./Fashion.vue?vue&type=script&setup=true&lang=js"
export * from "./Fashion.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Fashion.vue?vue&type=style&index=0&id=408ca7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408ca7a0",
  null
  
)

export default component.exports